import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-text">Транзакция в работе, ожидайте...</div>
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
